import Localization from 'lib/localization';

export default {
    lxButtonLoginText() {
        return Localization.get('badoo_homepage@button.login.text');
    },

    lxButtonSignupText() {
        return Localization.get('badoo_homepage@button.signup.text');
    },

    lxButtonGoogleSignupText() {
        return Localization.get('badoo_homepage@button.google.signup.text');
    },

    lxButtonFacebookSignupText() {
        return Localization.get('badoo_homepage@button.facebook.signup.text');
    },

    lxButtonAppleSignupText() {
        return Localization.get('badoo_homepage@button.apple.signup.text');
    },
    lxIllustrativeLabel() {
        return Localization.get('badoo_homepage@illustrative_purposes.label');
    },
};
